import React, { useEffect } from 'react'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Container } from 'react-bootstrap'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomForm from '../Components/CustomForm/CustomForm'
import {  fetchRestaurant, updateRestaurant } from '../hooks/resturant'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

function EditResturant() {
const dispatch = useDispatch();
const navigate = useNavigate();
const {id}=useParams()
const {singleRestaurant:restaurantData}=useSelector((state)=>state.resturants)
useEffect(() => {
dispatch(fetchRestaurant(id))
}, [])

    const infoData = [
  {
    id: 0,
    title: "معلومات أساسية",
    inputs: [
      { id: "name", title: "الاسم", type: "text" },
    ],
  },
];

const handleSubmit = (formData) => {
  console.log(formData);
  
  // formData will usually be an object like { name: "Restaurant Name" }
  dispatch(updateRestaurant(formData))
    .unwrap() // Allows us to use .then() / .catch() on the thunk result
    .then(() => {
      alert("تم تعديل المطعم بنجاح");
      navigate('/dashboard/resturants'); // Redirect to list page
    })
    .catch((err) => {
      // Error is already handled in Redux, but you can do specific UI logic here
      console.error("Failed to save:", err);
    });
};
return (
  <div>
      <AuthNavbar/>
        <Container>
                  <CustomHeader
        title={"تعديل مطعم "}
        subtitle={""}
        downloadData={false}
      />
      <CustomForm
formStructure={infoData}
image={false}
onSubmit={handleSubmit}
initialData={restaurantData}

      />
          </Container>
          </div>
)
}

export default EditResturant
